import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/atoms/Button"
import { Input } from "@/components/molecules/Input"
import { Card } from "@/components/molecules/Card"
import { useAuth } from "@/contexts/AuthContext"
import gaLogo from "@/assets/horizontal-logo.png"
import loginBG from "@/assets/login-bg.png"
import { Text } from "@/components/atoms"
import { useToast } from "@/hooks/useToast"

const Login = () => {
  const showToast = useToast()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const { login, isAuthenticated } = useAuth()

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/mentorings", { replace: true })
    }
  }, [isAuthenticated, navigate])

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!email || !password) {
      showToast({
        message: "Por favor, preencha todos os campos",
        variant: "error",
      })
      return
    }

    setIsLoading(true)
    try {
      await login(email, password)
      showToast({
        message: "Login realizado com sucesso",
        variant: "success",
      })
      navigate("/dashboard")
    } catch (error) {
      showToast({
        message: error.message || "Erro ao fazer login",
        variant: "error",
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-dark p-4"
      style={{
        backgroundImage: `url(${loginBG})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Card className="w-96">
        <div className="flex flex-col items-center">
          <div className="flex justify-center">
            <img
              src={gaLogo}
              width="70%"
            />
          </div>
          <Text variant="body">Painel de Mentorias</Text>
        </div>

        <form
          onSubmit={handleLogin}
          className="space-y-4"
        >
          <Input
            id="login"
            label="Login"
            placeholder="Digite seu login"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Input
            id="password"
            label="Senha"
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            isPassword
          />
          <div className="flex justify-center">
            <Button
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Entrando..." : "Entrar"}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  )
}

export default Login
